<div class="container-fluid">
  <div class="row" style="padding-bottom: 1em">
    <div class="row toolbarStickyHeader">
      <div class="col-8">
        <h3 style="color: White; padding-top: 0.25rem">
          <span *ngIf="!editQueryName">{{ queryName }} </span>
          <kendo-textbox #editQueryNameTextBox [hidden]="!editQueryName" value="{{queryName}}" style="margin-bottom: 5px; height: 35px;" (blur)="onEditQueryNameBlur()" (valueChange)="onQueryNameChange($event)"></kendo-textbox>
          <kendo-button [style.cursor]="!editQueryName ? 'pointer' : 'default'" *ngIf="!editQueryName && queryId > 0" (click)="toggleQueryNameEdit()" title="Edit Query Name">
            <kendo-icon name="pencil" size="medium" style="font-size: 20px; margin-bottom: 6px;"></kendo-icon>
          </kendo-button>
        </h3>
      </div>
      <div class="col-4">
        <app-toolbar></app-toolbar>
      </div>
    </div>
  </div>

  <div style="margin-top: 50px">
    <mat-sidenav-container style="background: #1e1e2d" hasBackdrop="false">
      <mat-sidenav
        #rightSidenav
        position="end"
        mode="over"
        [opened]="showSelectedFiltersPanel()"
        style="background: #1e1e2d; width: 25%"
        [fixedInViewport]="true"
        [fixedTopGap]="90"
        [fixedBottomGap]="0"
      >
        <app-right-side-section></app-right-side-section>
      </mat-sidenav>
      <mat-sidenav-content>
        <div class="row" style="background-color: #1e1e2d">
          <div class="col-lg-9">
            <app-indication-filters></app-indication-filters>
          </div>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>
